export default __webpack_public_path__ + "assets/icons/home_search.c64df02a.svg";